import React, { ReactElement } from 'react'

import { ServiceProviderCategoryEnum } from '../../../../../lib/graphql'
import { IconSvg } from '../../../../atoms'

export const mainPictureByServiceProviderType = (
  category?: ServiceProviderCategoryEnum,
): ReactElement => {
  const color = 'var(--clr-primary-400)'
  switch (category) {
    case ServiceProviderCategoryEnum.RESTAURATION:
      return <IconSvg.Restauration color={color} height={18} />
    case ServiceProviderCategoryEnum.TRANSPORT:
      return <IconSvg.Train color={color} width={18} height={18} />
    case ServiceProviderCategoryEnum.ACTIVITY:
      return <IconSvg.Racket color={color} height={19} />
    case ServiceProviderCategoryEnum.HOUSE:
      return <IconSvg.House color={color} height={22} />
    default:
      return <></>
  }
}
